export const STATUS_SOLICITACAO = {
  SOLICITADO: "SOLICITADO",
  PROCESSAMENTO_HASH_INICIAL: "PROCESSAMENTO_HASH_INICIAL",
  UPLOAD_CONCLUIDO: "UPLOAD_CONCLUIDO",
  ERRO_HASH_INICIAL: "ERRO_HASH_INICIAL",
  SOLICITADO_ASSINATURA_CONCLUIDO: "SOLICITADO_ASSINATURA_CONCLUIDO",
  CONCLUIDO: "CONCLUIDO",
  CANCELADO: "CANCELADO",
};

export const STATUS_DOCUMENTO = {
  DOCUMENTO_RECEBIDO: "DOCUMENTO_RECEBIDO",
  DOCUMENTO_AGUARDANDO_ASSINATURA: "DOCUMENTO_AGUARDANDO_ASSINATURA",
  DOCUMENTO_ASSINADO: "DOCUMENTO_ASSINADO",
  DOCUMENTO_CANCELADO: "DOCUMENTO_CANCELADO",
};

export const STATUS_SIGNATARIO = {
  AGUARDANDO_ONBOARDING: "AGUARDANDO_ONBOARDING",
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  SIGNED: "SIGNED",
  ERROR: "ERROR",
  CANCELADO: "CANCELADO",
};

export const TIPO_TERMO_RESPONSABILIDADE = {
  TERMO_DOCUMENTO: "TERMO_DOCUMENTO",
  TERMO_FOTO_PERFIL: "TERMO_FOTO_PERFIL",
};

export const PANEL_MOCK_STATE_KEY = "panelMockState";
